import React from "react";
import useFetch from "./fetch";

const withFetchHook = (Component) => {
  return (props) => {
    const fetch = useFetch();
    return <Component fetch={fetch} {...props} />;
  }
}

export default withFetchHook;
